import React from 'react';
import { MenuOption } from './MenuOption';
import { useSelector } from 'react-redux';
export function AsideMenuList({ layoutProps }) {
	const aside = useSelector((state) => state.menu.menu);

	return (
		<>
			{/* begin::Menu Nav */}
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				{/*begin::1 Level*/}
				{aside.data.aside.items.map((module) => (
					<MenuOption key={module.title} item={module} />
				))}
			</ul>

			{/* end::Menu Nav */}
		</>
	);
}
